import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import VisibilityIcon from "@mui/icons-material/Visibility";

const NotificationActionButtons = ({ notif, onAccept, onReject, onView }) => {
    return (
        <div style={{ display: 'flex', gap: 5 }} className="mt-2 "
        >
            {notif?.ND_action_status === 1 ? (
                <>
                    <Tooltip title="" placement="top">
                        <IconButton
                            size="small"
                            onClick={() => onAccept?.(notif)}
                            sx={{
                                color: "#2e7d32",
                                backgroundColor: "#e8f5e9",
                                border: "1px solid #c8e6c9",
                                "&:hover": { backgroundColor: "#c8e6c9" },
                                transition: "0.2s ease",
                                borderRadius: 3
                            }}
                        >
                            <CheckCircleIcon fontSize="small" />
                            <span>Accept</span>
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="" placement="top">
                        <IconButton
                            size="small"
                            onClick={() => onReject?.(notif)}
                            sx={{
                                color: "#c62828",
                                backgroundColor: "#ffebee",
                                border: "1px solid #ffcdd2",
                                "&:hover": { backgroundColor: "#ffcdd2" },
                                transition: "0.2s ease",
                                borderRadius: 3
                            }}
                        >
                            <CancelIcon fontSize="small" />
                            <span>Reject</span>
                        </IconButton>
                    </Tooltip>

                    {/* <Tooltip title="View Details" placement="top">
                        <IconButton
                            size="small"
                            onClick={() => onView?.(notif)}
                            sx={{
                                color: "#1565c0",
                                backgroundColor: "#e3f2fd",
                                "&:hover": { backgroundColor: "#bbdefb" },
                                transition: "0.2s ease",
                            }}
                        >
                            <VisibilityIcon fontSize="small" />
                        </IconButton>
                    </Tooltip> */}
                </>
            ) : (
                <Tooltip title="" placement="top">
                    <IconButton
                        size="small"
                        onClick={() => onView?.(notif)}
                        sx={{
                            color: "#1565c0",
                            backgroundColor: "#e3f2fd",
                            border: "1px solid #bbdefb",
                            "&:hover": { backgroundColor: "#bbdefb" },
                            transition: "0.2s ease",
                            borderRadius: 3
                        }}
                    >
                        <VisibilityIcon fontSize="small" />
                        <span>View</span>
                    </IconButton>
                </Tooltip>
            )}
        </div>
    );
};

export default NotificationActionButtons;
